<script>
import attachmentsService from '@/services/Attachments/attachmentsService';
import { CWLTipoPagamento, CWLInvestimentoDashboard } from '@/store/cwl_enums';
import moment from 'moment-timezone';

import XLSX from 'xlsx';

import { DoubleBounce } from 'vue-loading-spinner';

export default {
  name: 'financial-table',
  props: {
    columns: {
      type: Array,
      default: () => [],
      description: 'Table columns',
    },
    data: {
      type: Array,
      default: () => [],
      description: 'Table data',
    },
    campaign: {
      type: Object
    },
    type: {
      type: String,
      default: '',
      description: 'Whether table is striped or hover type',
    },
    theadClasses: {
      type: String,
      default: '',
      description: '<thead> css classes',
    },
    tbodyClasses: {
      type: String,
      default: '',
      description: '<tbody> css classes',
    },
    prazo: {
      type: String,
      default: ''
    }
  },
  components: {DoubleBounce},
  data() {
    return {
      page: 1,
      perPage: 1024,
      pages: [],
      CWLTipoPagamento: CWLTipoPagamento,
      CWLInvestimentoDashboard: CWLInvestimentoDashboard,

      items_exportar: [],
      pessoa: undefined,
      submodalidade: process.env.VUE_APP_SUBTYPE
    };
  },
  computed: {
    tableClass() {
      return this.type && `table-${this.type}`;
    },
    displayedData() {
      return this.paginate(this.data);
    },
  },
  mounted() {
    for ( const item of this.data ) {
      
      if ( this.pessoa == undefined ) {
        this.pessoa = item.pessoa;
      }

      //Item base independente de tipo de produto
      let baseItem = {
        INVESTIDOR: item.pessoa.nome,
        CPF: item.pessoa.documento.numero,
        EMAIL: item.pessoa.email.email,
        BANCO: item.pessoa.dados_complementares.dados_bancarios.banco.code,
        AGENCIA: item.pessoa.dados_complementares.dados_bancarios.agencia,
        CONTA: item.pessoa.dados_complementares.dados_bancarios.conta,
        VALOR_INVESTIMENTO: (item.item.value * item.item.quantity),
        STATUS: item.status,
        REMUNERACAO_ACUMULADA: (this.remuneracaoAcumulada(item)),
        VALOR_REMUNERACAO: (this.remuneracaoAcumulada(item) - (item.item.value * item.item.quantity)),
        CARENCIA_TOTAL: this.prazo
      };

      if ( this.submodalidade == "bacen" ) {
        baseItem = {
          NUMERO_CCB: item.ccb.numero_ccb || '--',
          CODIGO_OPERACAO: (item.ccb && item.ccb.importacao && item.ccb.importacao.operacao && item.ccb.importacao.operacao.operacao && item.ccb.importacao.operacao.operacao.operacao) ? item.ccb.importacao.operacao.operacao.operacao : '--',
          ...baseItem,          
        };
      } else {
        baseItem = { 
          CONTRATO: '--',
          ...baseItem,          
        }
      }

      this.items_exportar.push(baseItem); 
    }
  },
  methods: {
    getCCBOperacao(item) {
      let _operacao = "--";
      if (item.ccb && item.ccb.importacao && item.ccb.importacao.operacao && 
          item.ccb.importacao.operacao.operacao && item.ccb.importacao.operacao.operacao.operacao) {
          _operacao = item.ccb.importacao.operacao.operacao.operacao;
      }
      return _operacao;
    },
    getNumeroCCB(item) {
      let _numer_ccb = "--"
      if (item.ccb && item.ccb.numero_ccb) {
        _numer_ccb = item.ccb.numero_ccb
      }
      return _numer_ccb;
    },
    hasValue(item, column) {
      return item[column.toLowerCase()] !== 'undefined';
    },
    itemValue(item, column) {
      return item[column.toLowerCase()];
    },
    setPages() {
      if (this.pages) {
        this.pages = [];
      }

      const numberOfPages = Math.ceil(this.data.length / this.perPage);

      for (let index = 1; index <= numberOfPages; index++) {
        this.pages.push(index);
      }
    },
    paginate(data) {
      const page = this.page;
      const perPage = this.perPage;

      const from = (page * perPage) - perPage;
      const to = (page * perPage);

      return data.slice(from, to);
    },
    formatDate(date) {
      return moment(date).tz('America/Sao_Paulo').format('LLL');
    },
    async downloadContratoCCB(item) {
      try {
        let documento = this.pessoa.documento.numero.replace("-", "").replace(".", "").replace(".", "");
        let path = "ContratosCCB/" + this.campaign.id + "/" + documento;
        let filename =  "ContratoCCB_" + documento + "_" + item.ccb.numero_ccb + ".pdf";
        await attachmentsService.downloadAttachment(filename, path);
      }
      catch (e) {
        console.log(e);
      }
    },
    async downloadTermo(termo) {
      try {
        await attachmentsService.downloadAttachment(termo.name, termo.parent.fullPath);
      }
      catch (e) {
        console.log(e);
      }
    },
    remuneracaoAcumulada(order) {
      if ( this.campaign.fields['Encerramento da Oferta'] && this.campaign.fields['taxa_juros'] ) {
        let _valueAjustado = Number(order.item.value) * Number(order.item.quantity);
        let taxaJurosOferta = Number(this.campaign.fields['taxa_juros'].value);
        let dataEncerramentoOfertaString = this.campaign.fields['Encerramento da Oferta'].value;
        let dataAtual = moment();
        let dataEncerramentoOferta = moment(dataEncerramentoOfertaString, "YYYY-MM-DD");
        var diffMonths = dataAtual.diff(dataEncerramentoOferta, 'months');
        if ( diffMonths < 0 ) {
          diffMonths = diffMonths * -1;
        }
        else if ( diffMonths == 0 ) { // Se a diferença dos meses for 0, não efetua o cálculo e retorna o próprio valor aportado
          return _valueAjustado;
        }
        const paraCalcularPotencia = (1 + (taxaJurosOferta / 100));
        const diferencaParaCalcular = this.prazo.length > 0 ? Number(this.prazo) : diffMonths;
        const potenciaCalculada = Math.pow(paraCalcularPotencia, diferencaParaCalcular);
        var remuneracaoAcumuladaCalculo = _valueAjustado * potenciaCalculada;
        return remuneracaoAcumuladaCalculo;
      }
      else {
        return 0;
      }
    },

    download() {
      let nomeArquivo = this.campaign.name.replace(" ", "_").replace(" ", "_").replace(" ", "_").replace(" ", "_").replace(" ", "_") + ".xlsx";
      const data = XLSX.utils.json_to_sheet(this.items_exportar);

      let columnsToFormat = this.submodalidade == "588" ? ['H', 'J', 'K'] : ['I', 'K', 'L'];
      
      columnsToFormat.forEach((customCol) => {
        for (let i = 2; i <= this.items_exportar.length + 1; i++) {
          data[customCol + i].z = 'R$ #,##0.00';
        }
      });
      const wb = XLSX.utils.book_new();
      XLSX.utils.book_append_sheet(wb, data, 'Vencimentos');
      XLSX.writeFile(wb, nomeArquivo);
    },
  },
  watch: {
    data() {
      this.setPages();
    },
  },
};
</script>

<template>
  <div>
    <table class="table tablesorter" :class="tableClass">
      <thead :class="theadClasses">
      <tr>
        <slot name="columns">
          <th v-for="column in columns" :key="column">{{column}}</th>
        </slot>
      </tr>
      </thead>
      <tbody :class="tbodyClasses">
        <tr v-for="(item, index) in displayedData" :key="index">
          <td v-if="prazo.length > 0">{{ item.pessoa.nome }}</td>
          <td v-if="prazo.length > 0">{{ item.pessoa.documento.numero }}</td>
          <td v-if="prazo.length > 0">{{ item.pessoa.email.email }}</td>
          <td v-if="prazo.length > 0">{{ item.pessoa.dados_complementares.dados_bancarios.banco.code }}</td>
          <td v-if="prazo.length > 0">{{ item.pessoa.dados_complementares.dados_bancarios.agencia }}</td>
          <td v-if="prazo.length > 0">{{ item.pessoa.dados_complementares.dados_bancarios.conta }}</td>
          <td v-if="prazo.length > 0 && submodalidade != '588'"> {{ getCCBOperacao(item) }} </td>
          <td v-if="prazo.length > 0"> {{ getNumeroCCB(item) }} </td>
          
          <td>{{ (item.item.value * item.item.quantity) | currency }}</td>
          <td v-if="item.tipo_pagamento === CWLTipoPagamento.CartaoCredito && prazo.length == 0">Cartão de Crédito</td>
          <td v-if="item.tipo_pagamento === CWLTipoPagamento.Boleto && prazo.length == 0">Boleto</td>
          <td v-if="item.tipo_pagamento === CWLTipoPagamento.Reservado && prazo.length == 0">Reservado</td>
          <td v-if="item.tipo_pagamento === CWLTipoPagamento.TED && prazo.length == 0">TED</td>
          <td v-if="item.tipo_pagamento === CWLTipoPagamento.PIX && prazo.length == 0">PIX</td>
          <td v-if="item.tipo_pagamento === 'PIX' && prazo.length == 0">PIX</td>
          <td v-if="prazo.length == 0">{{ formatDate(item.order_date)  }}</td>
          <td>{{ item.status }}</td>           
          <td v-if="item.status != 'Pago'"> -- </td>
          <td v-if="item.status == 'Pago'">{{ remuneracaoAcumulada(item) | currency }}</td>

          <td v-if="prazo.length > 0 && item.status == 'Pago'"> {{ ( remuneracaoAcumulada(item) - (item.item.value * item.item.quantity) ) | currency }} </td>
          <td v-if="prazo.length > 0 && item.status != 'Pago'"> -- </td>

          <td v-if="prazo.length > 0"> {{ prazo }} </td>

          <td v-if="prazo.length == 0">
            <i v-if="submodalidade == 'bacen' && item.ccb && item.ccb.numero_ccb && item.ccb.possui_contrato_download" title="Download Contrato CCB" class="tim-icons icon-cloud-download-93" @click="downloadContratoCCB(item)"></i>
            <div v-for="(termo, index) in item.termos" :key="index" style="display: inline; margin-right: 5px;">
              <i v-if="submodalidade == '588'" :title="'Download ' + termo.name" class="tim-icons icon-cloud-download-93" 
              @click="downloadTermo(termo)"></i>
            </div>
          </td>
        </tr>
      </tbody>
    </table>

    <nav class="table-pagination">
      <ul class="pagination">
        <li class="page-item">
          <button
            type="button"
            class="page-link"
            v-if="page != 1"
            @click="page--"
          >
            <i class="fas fa-angle-left"></i>
          </button>
        </li>

        <li class="page-item">
          <button
            type="button"
            class="page-link"
            v-for="(pageNumber, index) in pages.slice(page - 1, page + 5)"
            :key="index"
            @click="page = pageNumber"
            :class="{ 'is-active': page === pageNumber }"
          >
            {{ pageNumber }}
          </button>
        </li>

        <li class="page-item">
          <button
            type="button"
            class="page-link"
            v-if="page < pages.length"
            @click="page++"
          >
            <i class="fas fa-angle-right"></i>
          </button>
        </li>
      </ul>
    </nav>

    <div class="row">
      <div class="export-button">
        <button
          class="btn btn-primary"
          @click="download"
          :disabled="!displayedData.length"
          :hidden="!prazo"
        >
          <i class="tim-icons icon-cloud-download-93"></i>
          Exportar para Excel
        </button>
      </div>
    </div>
  </div>
</template>
